/**
 * A set of example lead data.
 */
export const EXAMPLE_LEAD: Record<string, string> = {
  mainApplicant_salutation: 'Frau',
  mainApplicant_firstName: 'Angelika',
  mainApplicant_lastName: 'Meier',
  mainApplicant_birthday: '1980-02-01',
  financingPurpose: 'Neubau',
  object_type: 'Einfamilienhaus',
  object_city: 'Lübeck',
  object_zipCode: '23556',
  object_useOfTheProperty: 'Eigennutzung',
  mainApplicant_zipCode: '23558',
  mainApplicant_city: 'Lübeck',
  mainApplicant_email: 'main@example.com',
  loanAmount: '400000',
  loanType: 'Einrichtung',
  loanTerm: '10',
  numberOfPersonsInHousehold: '4',
  'coApplicant_*_firstName': 'Alois',
  'coApplicant_*_lastName': 'Permaneder',
  'coApplicant_*_birthday': '1981-02-01',
};
